import vendorDashboardAPI from '@/utils/api/vendorDashboard';
import { genericError } from '@/utils/alerts.service';

export const detail = {
  namespaced: true,
  state: {
    contactDetail: {},
  },
  getters: {
    contactDetail(state) {
      return state.contactDetail;
    },
  },
  mutations: {
    setContactDetail(state, data) {
      state.contactDetail = data;
    },
  },
  actions: {
    async fetchContactDetail({ dispatch, commit }, id) {
      return vendorDashboardAPI
        .getContactDetail(id)
        .then(data => {
          commit('setContactDetail', data);
        })
        .catch(() => {
          dispatch('showUserMessage', { ...genericError }, { root: true });
        });
    },
  },
};
